import { cn } from "@/lib/utils";
import { ArrowLeft } from "lucide-react";
import { useRouter } from "@tanstack/react-router";

interface MobilePageHeaderProps {
  title: string;
  breadcrumb?: string;
  onBack?: () => void;
  children?: React.ReactNode;
  className?: string;
  sticky?: boolean;
}

export function MobilePageHeader({
  title,
  breadcrumb,
  onBack,
  children,
  className,
  sticky = true,
}: MobilePageHeaderProps) {
  const router = useRouter();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      router.history.back();
    }
  };

  return (
    <header
      className={cn(
        "bg-white px-[var(--page-padding)] py-[var(--space-md)]",
        "border-b border-copilot-neutral-border",
        sticky && "sticky top-0 z-40",
        className
      )}
    >
      {(breadcrumb || onBack) && (
        <div className="flex items-center gap-2 mb-2">
          <button
            onClick={handleBack}
            className="w-9 h-9 rounded-full border border-copilot-neutral-border flex items-center justify-center bg-white shrink-0 text-copilot-text-secondary hover:bg-copilot-surface-sunken transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft size={18} />
          </button>
          {breadcrumb && (
            <span className="text-xs font-medium text-copilot-text-secondary truncate">
              {breadcrumb}
            </span>
          )}
        </div>
      )}
      <h1
        className="text-[var(--heading-page-size)] font-bold leading-[var(--heading-page-lh)] text-copilot-text-primary"
      >
        {title}
      </h1>
      {children}
    </header>
  );
}
